<template>
  <div v-if="hasCardStyle" class="otb-footnotes otb-footnotes--card">
    <h5
      class="otb-footnotes__title otb-footnotes--card__title wb-type-hint-strong"
    >
      {{ title }}
    </h5>
    <div
      class="otb-footnotes__body otb-footnotes--card__body wb-type-hint"
      v-html="body"
    ></div>
  </div>
  <div v-else class="otb-footnotes">
    <p class="otb-footnotes__title wb-type-copy-tertiary">
      <template v-if="title"> {{ title }}: </template>
      <span class="otb-footnotes__body" v-html="body"></span>
    </p>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  name: 'otb-footnotes',
  props: {
    title: String as () => string | TranslateResult,
    body: String as () => string | TranslateResult,
    hasCardStyle: Boolean as () => boolean,
  },
});
</script>
<style lang="scss" src="./footnotes.scss"></style>
